// usage:
// if (selectedPlatform |> inIn(['instagram', 'instagram_stories', 'youtube'])) {
//   console.log("You're an influencer!")
// }
export default collection => item => collection.indexOf(item) !== -1
